import { useEffect } from 'react';

import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Logo } from '~/components/ui/logo';
import { identify } from '~/libs/analytics';
import { usePagePresence } from '~/libs/presence';

export function AppLoader() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Logo className="size-12 animate-pulse" />
    </div>
  );
}

export const Route = createFileRoute('/_auth')({
  component: withAuthenticationRequired(RouteComponent, {
    onRedirecting: AppLoader,
  }),
});

function RouteComponent() {
  const { user } = useAuth0();

  useEffect(() => {
    if (user) {
      const encoder = new TextEncoder();
      const data = encoder.encode(user.email ?? undefined);
      void window.crypto.subtle.digest('SHA-256', data).then((hash) => {
        const hashArray = Array.from(new Uint8Array(hash));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, '0'))
          .join('');
        identify(hashHex);
      });
    }
  }, [user]);

  usePagePresence();

  return <Outlet />;
}
